import { Component, OnInit, Input, ViewChild, HostListener, ElementRef, Output, NgZone, EventEmitter, ChangeDetectorRef, ChangeDetectionStrategy, Renderer2, OnChanges, SimpleChanges} from '@angular/core'
import { Subject, interval } from 'rxjs';
import { takeUntil } from 'rxjs/operators';
import { Chat } from '../../../../models/chat'
import { AccountManagerService } from '../../../services/account/account-manager.service'
import { VideoCallService } from './video-call.service'
import { MessageVideoCallInfo } from '../../../../models/message-video-call'
import { UserContactService } from '../../../services/data/user-contact/user-contact.service';

import * as _ from 'lodash'

import adapter from 'webrtc-adapter'
import Janus from '../../../../webclient/services/janus/janus.js'
import { isArray } from 'lodash'

export interface TimeSpan {
  hours: number;
  minutes: number;
  seconds: number;
}

@Component({
  selector: 'tn-video-call',
  templateUrl: './video-call.component.html',
  styleUrls: ['./video-call.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush
})
export class VideoCallComponent implements OnInit {
  @Input() isVideoCall: boolean
  @Input() chat: Chat
  @Input() isAdmin: boolean
  @Output() stopVideoCall = new EventEmitter<{isVideoCall: boolean, isCallByMe: boolean, isGroup: boolean}>()

  @ViewChild('localVideo') localVideo: ElementRef
  @ViewChild('localAudio') localAudio: ElementRef

  @ViewChild('remoteVideo') remoteVideo: ElementRef
  @ViewChild('remoteAudio') remoteAudio: ElementRef

  @ViewChild('videoContainer') videoContainer: ElementRef

  janus: any = null
  videoCallPluginHandler: any = null

  // janus related instance
  localMediaStream: any = null
  localTracks = {}
  localVideoNum: number = 0

  feedStreams = {}
  feeds: any[] = []
  bitrateTimer: any[] = []

  mystream: any = null
  myId: any = null
  myPrivateId: any = null

  isAudioMuted: boolean = false
  isLocalVideoMuted: boolean = true

  isSoundMuted: boolean = false

  isRinging: boolean = false
  isCallByMe: any = null
  isGroup: any = null
  caller: string = ''

  isRemoteVideoMuted: boolean = false
  isRemoteAudioMuted: boolean = false
  isRemoteConnected: boolean = false

  videoCallInfo: MessageVideoCallInfo = null
  janusServerEndPoint: string = null
  videoRoomId: number = null
  videoRoomPIN: string = null

  videoCallStartTime: any = null

  isButtonGpShowing: boolean = true
  timer: any

  private destroyed$ = new Subject();

  constructor(
    private changeDetector: ChangeDetectorRef,
    private _accountManagerService: AccountManagerService,
    private _videoCallService: VideoCallService,
    private _userContactService: UserContactService,
    private mediaEl: ElementRef,
    private renderer: Renderer2,
    private ngZone: NgZone
  ) {}
  ngOnInit() {
    // default to show the video call button group for 3 sec
    this.timer = setTimeout(() => { 
      this.isButtonGpShowing = false
    }, 3000)


    
    this.isCallByMe = this._videoCallService.isCallByMe;
    this.isGroup = this._videoCallService.isGroup;
    this.caller = this._videoCallService.callerUserId
    // if (this.isCallByMe === false) {
    //   // this.isRemoteConnected = true;
    //   this.videoCallStartTime = new Date().getTime();
    // }
    this.videoCallInfo = this._videoCallService.getVideoCallInfo()

    if (!this.videoCallInfo) {
      alert('target message is invalid')
      return
    }
    
    interval(1000).pipe(takeUntil(this.destroyed$)).subscribe(() => {
      if (!this.changeDetector['destroyed']) {
        this.changeDetector.detectChanges();
      }
    });

    this.changeDetector.detectChanges();

    let { ws_endpoint, room_id, pin } = this.videoCallInfo

    this.janusServerEndPoint = ws_endpoint
    this.videoRoomId = room_id
    this.videoRoomPIN = pin

    this.janusInit();
  }

  ngOnDestroy() {
    // if (this.isGroup) {
    //   let unpublish = { request: "unpublish" };
	  //   this.videoCallPluginHandler.send({ message: unpublish });
    // }

    this.hangup();
   
    this.mystream = null
    delete this.feedStreams[this.myId]
    this.localTracks = {}
    this.localVideoNum = 0

    if (this.janus) {
      this.janus.destroy()
    }
    // this.janus = null

    this._videoCallService.isVideoCalling = false;
    // console.log(this.getElapsedTime()) // get the video call end time
    // this._videoCallService.initVideoCallInfo()

    this.destroyed$.next();
    this.destroyed$.complete();
  }

  getVideoCallTime(): TimeSpan {        
    let totalSeconds = Math.floor((new Date().getTime() - this.videoCallStartTime) / 1000);
    let hours = 0;
    let minutes = 0;
    let seconds = 0;

    if (totalSeconds >= 3600) {
      hours = Math.floor(totalSeconds / 3600);      
      totalSeconds -= 3600 * hours;      
    }

    if (totalSeconds >= 60) {
      minutes = Math.floor(totalSeconds / 60);
      totalSeconds -= 60 * minutes;
    }

    seconds = totalSeconds;
    
    return {
      hours: hours,
      minutes: minutes,
      seconds: seconds
    };
  }

  janusInit(): void {
    Janus.init({
      debug: true,
      dependencies: Janus.useDefaultDependencies({ adapter: adapter }),
      callback: () => {
        if (!Janus.isWebrtcSupported()) {
          console.log('not Supported Webrtc!')
          return
        }

        // Create session
        this.janus = new Janus({
          server: this.janusServerEndPoint,
          // success: this.janusPluginAttach.bind(this),
          success: () => {
            // console.log('new Janus success, is connected? : ', this.janus.isConnected())
            let callPluginAttach = this.janusPluginAttach.bind(this)
            callPluginAttach(this.videoRoomId, this.videoRoomPIN)
          },
          error: (cause) => {
            console.error(cause)
          },
          destroyed: () => {
            console.log('destroyed')
          }
        })
      }
    })
  }

  janusPluginAttach(room_id: any, room_pin: string): void {
    if (!this.janus) {
      return
    }

    this.janus.attach({
      plugin: 'janus.plugin.videoroom',
      success: (pluginHandle: any) => {
        this.videoCallStartTime = new Date().getTime();
        this.videoCallPluginHandler = pluginHandle

        Janus.log(
          'Plugin attached! (' +
            this.videoCallPluginHandler.getPlugin() +
            ', id=' +
            this.videoCallPluginHandler.getId() +
            ')'
        )
        Janus.log('  -- This is a publisher/manager')

        // Prepare the username registration
        let register = {
          request: 'join',
          room: room_id,
          pin: room_pin,
          ptype: 'publisher',
          display: this._accountManagerService.userId
        }

        this.videoCallPluginHandler.send({ message: register })
      },
      error: (err) => {
        Janus.error('  -- Error attaching plugin...', err)
      },
      onmessage: (msg: any, jsep: any) => {
        Janus.log(' ::: Got a message (publisher) :::', msg)
        let event = msg['videoroom']
        Janus.log('Event: ', event)

        if (event) {
          if (event === 'joined') {
            Janus.log('------ Successfully joined room ' + msg['room'] + ' with ID ' + msg.id)
            this.myId = msg.id
            this.myPrivateId = msg.private_id

            this.publishOwnFeed()

            if (msg.publishers && Array.isArray(msg.publishers)) {
              let pulisherList = msg.publishers
              // console.log(pulisherList)

              this.storeFeedStreams(pulisherList)
            }
          } else if (event === 'destroyed') {

            Janus.warn('------ The room has been destroyed! ------')
          } else if (event === 'event') {
            Janus.log("------ event ==> event ------, receive user/user'stream info from the publisher (caller)")

            if (msg['streams']) {
              Janus.log('------ event ==> streams ------')
              let streams = msg['streams']
              for (let i in streams) {
                let stream = streams[i]
                stream['id'] = this.myId
                stream['display'] = this._accountManagerService.userId
              }
              this.feedStreams[this.myId] = streams
            } else if (msg['publishers']) {
              console.log('------ event ==> publishers ------, when I call the other & the other accept the call and joined my room')
              // if (this.isCallByMe === true) {
              //   this.isRemoteConnected = true;
              //   this.videoCallStartTime = new Date().getTime();
              // }

              if (msg.publishers && Array.isArray(msg.publishers)) {
                let pulisherList = msg.publishers
                console.log('pulisherList', pulisherList)

                this.storeFeedStreams(pulisherList)
              }
            } else if (msg['leaving']) {
              // One of the publishers has gone away?
              let leaving = msg.leaving
              Janus.log('Publisher left "leaving": ' + leaving)
              
              let leavingRemoteFeed = null

              for (let i = 1; i < this.chat.members.length; i++) {
                if (this.feeds[i] && this.feeds[i].rfid == leaving) {
                  console.log('!!!!!!')
                  leavingRemoteFeed = this.feeds[i]
                  break
                }
              }

              if (leavingRemoteFeed) {
                Janus.debug(
                  'Feed ' + leavingRemoteFeed.rfid + ' (' + leavingRemoteFeed.rfdisplay + ') has left the room, detaching'
                )

                // this.feeds[remoteFeed.rfindex] = null
                _.remove(this.feeds, (rf) => {
                  return rf && rf.rfid && rf.rfid == leavingRemoteFeed.rfid;
                })
                this.changeDetector.markForCheck();
                
                leavingRemoteFeed.detach()
              }
              delete this.feedStreams[leaving]

              if (this.isGroup) {
                // The call ends only when the caller leaves
                if (leavingRemoteFeed.user_id && leavingRemoteFeed.user_id === this.caller) {
                  console.log('the caller has left .....................')
                  this.endVideoCall()
                }
              } else {
                // either party leaving will end the call in p2p
                this.endVideoCall()
              }
            } else if (msg.error) {
              if (msg.error_code === 426) {
                console.error(msg.error)
              } else { }
            }
          }
        }

        if (jsep) {
          Janus.log('Handling SDP as well...', jsep)
          this.videoCallPluginHandler.handleRemoteJsep({ jsep: jsep })
          // Check if any of the media we wanted to publish has
          // been rejected (e.g., wrong or unsupported codec)
          let audio = msg.audio_codec

          if (
            this.mystream &&
            this.mystream.getAudioTracks() &&
            this.mystream.getAudioTracks().length > 0 &&
            !audio
          ) {
            // Audio has been rejected
            Janus.warn("audio stream has been rejected, viewers won't hear us")
          }
          let video = msg.video_codec
          if (
            this.mystream &&
            this.mystream.getVideoTracks() &&
            this.mystream.getVideoTracks().length > 0 &&
            !video
          ) {
            // Video has been rejected
            Janus.warn("Our video stream has been rejected, viewers won't see us")
            // do something to Hide the webcam video
          }
        }
      },
      onlocaltrack: (track: any, on: any) => {
        Janus.log('Local track ' + (on ? 'added' : 'removed') + ':', track)

        let trackId = track.id.replace(/[{}]/g, '')

        if (!on) {
          console.log('------- stopping local track -------')
          let stream = this.localTracks[trackId]
          if (stream) {
            try {
              let tracks = stream.getTracks()
              for (let i in tracks) {
                let mst = tracks[i]
                if (mst !== null && mst !== undefined) {
                  mst.stop()
                }
              }
            } catch (err) {}
          }

          if (track.kind === 'video') {
            this.localVideoNum--;
          }

          delete this.localTracks[trackId]
          return
        }

        // If we're here, a new track was added
        let stream = this.localTracks[trackId]

        if (stream) {
          // We've been here already
          return
        }

        if (track.kind === 'audio') {
          // ignore local audio tracks
        } else {
          // New video track: create a stream out of it
          this.localVideoNum++

          stream = new MediaStream([track])
          this.localTracks[trackId] = stream
          Janus.log('Created local stream:', stream)
          Janus.log(stream.getTracks())
          Janus.log(stream.getVideoTracks())

          Janus.attachMediaStream(this.localVideo.nativeElement, stream)
        }

        // get the local video stream mute status
        this.isLocalVideoMuted = this.videoCallPluginHandler.isVideoMuted()
        // Set the local video to off by default
        if (!this.isLocalVideoMuted) {
          this.videoCallPluginHandler.muteVideo()
          this.videoCallPluginHandler.send({message: { request: 'configure', video: false }})
          this.isLocalVideoMuted = !this.isLocalVideoMuted
        }

        if (
          this.videoCallPluginHandler.webrtcStuff.pc.iceConnectionState !== 'completed' &&
          this.videoCallPluginHandler.webrtcStuff.pc.iceConnectionState !== 'connected'
        ) {
          Janus.log('--- iceConnectionState completed ---')
        }
      },
      onremotetrack: function (track, mid, on) {
        // The publisher stream is sendonly, we don't expect anything here
      },
      iceState: (state) => {
        Janus.log('ICE state changed to ', state)
      },
      mediaState: (medium, on, mid) => {
        Janus.log('Janus ' + (on ? 'started' : 'stopped') + ' receiving our ' + medium + ' (mid=' + mid + ')')
      },
      slowLink: function(uplink, lost, mid) {
        Janus.warn("Janus reports problems " + (uplink ? "sending" : "receiving") +
          " packets on mid " + mid + " (" + lost + " lost packets)");
      },
      oncleanup: () => {
        Janus.log(' ::: Got a cleanup notification: we are unpublished now :::')

        this.mystream = null
        this.localTracks = {}
        this.localVideoNum = 0
        delete this.feedStreams[this.myId]

      }
    })
  }

  storeFeedStreams(publishers: any[]): void {
    for (let index = 0; index < publishers.length; index++) {
      if (publishers[index].dummy) {
        continue
      }

      let id = publishers[index].id
      let display = publishers[index].display
      let streams = publishers[index].streams

      if (streams) {
        _.forEach(streams, (stream) => {
          stream.id = id
          stream.display = display
        })
      }
      this.feedStreams[id] = streams
      Janus.log('  >> [' + id + '] ' + display + ':', streams)
      this.createNewRemoteFeed(id, display, streams)
    }
  }

  publishOwnFeed(): void {
    let tracks = []
    tracks.push({ type: 'audio', capture: true, recv: false })
    tracks.push({ type: 'video', capture: true, recv: false })

    // ready to create a offer and then send the offer SDP
    this.createOffer(tracks)
  }

  createOffer(tracks: any[]): void {
    this.videoCallPluginHandler.createOffer({
      tracks: tracks,
      success: (jsep: any) => {
        Janus.log('Got publisher SDP!', jsep)
        // here to set the the default status for the local track
        let publish = { request: 'configure', audio: true, video: false } 

        publish['audiocodec'] = 'opus'
        publish['videocodec'] = 'vp9'

        // send offer SDP
        Janus.log('------ send offer SDP ------')
        this.videoCallPluginHandler.send({ message: publish, jsep: jsep })
      },
      error: function (error) {
        Janus.error('WebRTC error:', error)
      }
    })
  }

  createNewRemoteFeed(id: number, display: string, streams): void {    
    console.log('------ createNewRemoteFeed ------')
    let remoteFeed: any = null

    if (!streams) {
      streams = this.feedStreams[id]
    }

    console.log(streams)
    console.log(this.feedStreams[id])

    this.janus.attach({
      plugin: 'janus.plugin.videoroom',
      success: (pluginHandle: any) => {
        remoteFeed = pluginHandle
        remoteFeed.remoteTracks = {}
        remoteFeed.remoteVideos = 0
        remoteFeed.remoteAudios = 0
        remoteFeed.user_id = display
        remoteFeed.rfid = id
        // remoteFeed.isRemoteVideoMuted = true

        Janus.log('Plugin attached! (' + remoteFeed.getPlugin() + ', id=' + remoteFeed.getId() + ')')
        Janus.log('  -- This is a subscriber')

        // this.videoCallStartTime = new Date().getTime();

        let subscription = []

        if (streams && streams.length > 0) {
          for (let index = 0; index < streams.length; index++) {
            let stream = streams[index]

            if (
              stream.type === 'video' &&
              Janus.webRTCAdapter.browserDetails.browser === 'safari' &&
              (stream.codec === 'vp9' || (stream.codec === 'vp8' && !Janus.safariVp8))
            ) {
              // If the publisher is VP8/VP9 and this is an older Safari, let's avoid video
              continue
            }

            subscription.push({
              feed: stream.id,
              mid: stream.mid
            })

            remoteFeed.rfid = stream.id
            remoteFeed.rfdisplay = stream.display
          }
        }

        // wait for the plugin to send an offer
        let subscribe = {
          request: 'join',
          room: this.videoRoomId,
          pin: this.videoRoomPIN,
          ptype: 'subscriber',
          // streams: subscription,
          feed: id, // publisher' id
          private_id: this.myPrivateId
        }

        if (!_.isEmpty(subscription)) {
          subscribe['streams'] = subscription
        }

        console.log('------ send subscribe ------')
        remoteFeed.send({ message: subscribe })
      },
      onmessage: async (msg, jsep) => {
        Janus.log(' ::: Got a message (subscriber) :::', msg)
        let event = msg.videoroom
        Janus.log('Event: ', event)

        if (msg.error) {
          console.error(msg.error)
        } else if (event) {
          if (event === 'attached') {
            console.log('event === "attached"', remoteFeed.user_id)

            try {
              let userInfo = await this._videoCallService.getAvatarByUserId(remoteFeed.user_id)

              for (let i = 1; i < this.chat.members.length; i++) {
                if (!this.feeds[i]) {
                  remoteFeed.rfindex = i
                  remoteFeed.userInfo = userInfo
                  this.feeds[i] = remoteFeed
                  break
                }
              }

              // markForCheck() for marking the changes, it will re-render the view later
              this.changeDetector.markForCheck();
              
            } catch (error) {
              let user = this._userContactService.getUserContactByUserId(remoteFeed.user_id);

              for (let i = 1; i < this.chat.members.length; i++) {
                if (!this.feeds[i]) {
                  remoteFeed.rfindex = i
                  remoteFeed.userInfo = {
                    name: user.name,
                    avatarImageSrc: 'url(/assets/images/general/default_avatar.png)'
                  }
                  this.feeds[i] = remoteFeed
                  break
                }
              }

              this.changeDetector.markForCheck();
            }

            // Subscriber created and attached
            // for (let i = 1; i < this.chat.members.length; i++) {
            //   if (!this.feeds[i]) {
            //     this.feeds[i] = remoteFeed
            //     remoteFeed.rfindex = i
            //     break
            //   }
            // }

            Janus.log('Successfully attached to feed in room ' + msg['room'])
          } else if (event === 'event') {
            // Check if we got a simulcast-related event from this publisher
            let substream = msg.substream
            let temporal = msg.temporal
          } else {
            // handle other event here...
          }
        }

        if (jsep) {
          Janus.log('Handling SDP as well...', jsep)
          let stereo = jsep.sdp.indexOf('stereo=1') !== -1
          // Answer and attach
          remoteFeed.createAnswer({
            jsep: jsep,
            tracks: [{ type: 'data' }],
            customizeSdp: function (jsep) {
              if (stereo && jsep.sdp.indexOf('stereo=1') == -1) {
                // Make sure that our offer contains stereo too
                jsep.sdp = jsep.sdp.replace('useinbandfec=1', 'useinbandfec=1;stereo=1')
              }
            },
            success: function (jsep) {
              Janus.debug('Got SDP!', jsep)
              let body = { request: 'start', room: this.videoRoomId }
              remoteFeed.send({ message: body, jsep: jsep })
            },
            error: function (error) {
              Janus.error('WebRTC error:', error)
            }
          })
        }
      },
      onlocaltrack: (track, on) => {
        // The subscriber stream is recvonly, we don't expect anything here
      },
      onremotetrack: (track, mid, on, metadata) => {
        /*
          track: hold the track info object, (e.g track.kind === 'video')
          mid: 'audio' || 'video',
          on: true || false,
          metadata: (e.g metadata.reason === 'created')
        */
        Janus.log('------ handle remote', '[', mid, ']', ' track ------')
        // handle remote track
        Janus.log(
          'Remote feed #' +
            remoteFeed.rfindex +
            ', remote track (mid=' +
            mid +
            ') ' +
            (on ? 'added' : 'removed') +
            (metadata ? ' (' + metadata.reason + ') ' : '') +
            ':',
          track
        )

        // if (!this.isCallByMe) {
        //   this.isRemoteConnected = true;
        // }

        // if (metadata.reason === 'unmute' ) {
        //   this.isRemoteConnected = true;
        // }
        console.log(metadata)

        
        if (!on) {
          this.isRemoteConnected = true;
          // if remote audio/video track is removed (mute) || removed (ended)
          console.log('~~~~~~~~~~~~~remoteFeed', remoteFeed)
          if (track.kind === 'video') {
            console.log(remoteFeed.remoteVideos);
            remoteFeed.remoteVideos--

            console.log(remoteFeed.remoteVideos);

            console.log(remoteFeed);
            if (remoteFeed.remoteVideos === 0) {
              remoteFeed.isRemoteVideoMuted = true
            }

          } else if (track.kind === 'audio') {
            remoteFeed.remoteAudios--

            if (remoteFeed.remoteAudios === 0) {
              remoteFeed.isRemoteAudioMuted = true
            }
          }

          this.changeDetector.markForCheck();

          delete remoteFeed.remoteTracks[mid]
          return
        }

        // If we're here, a new track was added
        if (remoteFeed.spinner) {
          remoteFeed.spinner.stop()
          remoteFeed.spinner = null
        }

        // handle remote audio & video track init & status changes (mute || unmute)
        if (track.kind === 'audio') {
          console.log('audio track', track)
          remoteFeed.remoteAudios++
          let stream = new MediaStream([track])
          remoteFeed.remoteTracks[mid] = stream
          Janus.log('Created remote audio stream:', stream)

          // console.log('this.isRemoteAudioMuted', this.isRemoteAudioMuted)

          if (track.muted) {
            this.isRemoteAudioMuted = true
          } else if (metadata.reason === 'unmute') {
            this.isRemoteAudioMuted = false  
          }
          

          let remoteAudioEl = this.mediaEl.nativeElement.querySelector(`#remoteAudio${remoteFeed.rfindex}-audio`);
          if (remoteAudioEl) {
            Janus.attachMediaStream(remoteAudioEl, stream);
          }

        } else {
          
          // New video track: create a stream out of it
          // remoteFeed.remoteVideos++
          let stream = new MediaStream([track])
          remoteFeed.remoteTracks[mid] = stream
          Janus.log('Created remote video stream:', stream)

          // if (track.muted) {
          //   this.isRemoteVideoMuted = true
            
          //   // this.isRemoteConnected = true;
          // } else if (metadata.reason === 'unmute') {
          //   this.isRemoteVideoMuted = false
          //   console.log(track.muted)
          //   if (!track.muted && !this.isCallByMe) {
          //     console.log('this.isRemoteConnected = true;this.isRemoteConnected = true;this.isRemoteConnected = true;')
          //     this.isRemoteConnected = true;
          //   }
          // }

          if (metadata.reason === 'created') {
            // remoteFeed.remoteVideos++
          } else if(metadata.reason === 'unmute') {
            console.log(track);
            remoteFeed.remoteVideos++
            console.log(remoteFeed.remoteVideos)
            console.log(remoteFeed.isVideoMuted())
     

            if (track.muted) {
              remoteFeed.isRemoteVideoMuted = true
            } else {
              remoteFeed.isRemoteVideoMuted = false
            }

            // if (remoteFeed.remoteVideos === 0) {
            //   remoteFeed.isRemoteVideoMuted = false
            // }

            // if (remoteFeed.remoteVideos === 0) {
            //   remoteFeed.remoteVideos++
            // }

            
            //   // if (!this.isCallByMe) {
            //   //   this.isRemoteConnected = true;
            //   // }
            // }
          } else if (metadata.reason === 'mute') {
            remoteFeed.isRemoteVideoMuted = true
          }

          this.changeDetector.markForCheck();

          console.log('remoteFeed', remoteFeed.rfindex);
          // handle remote video track' init & mute changes
          let remoteVideoEl = this.mediaEl.nativeElement.querySelector(`#remoteVideo${remoteFeed.rfindex}-video`);
          console.log(remoteVideoEl)
          if (remoteVideoEl) {
            Janus.attachMediaStream(remoteVideoEl, stream);
            
          }

          // Note: we'll need this for additional videos too
          if (!this.bitrateTimer[remoteFeed.rfindex]) { }
        }
      },
      oncleanup: () => {
        Janus.log(' ::: Got a cleanup notification (remote feed ' + id + ') unpublished now :::')
        if (remoteFeed.spinner) {
          remoteFeed.spinner.stop()
        }
        
        // clear remote video/audio stream handler
        remoteFeed.spinner = null
        this.bitrateTimer[remoteFeed.rfindex] = null
        remoteFeed.remoteTracks = {}
        remoteFeed.remoteVideos = 0
        remoteFeed.remoteAudios = 0
        
        // if (!this.isGroup) {
        //   // end the current video call session after the caller is left
        //   this.endVideoCall()
        // } 
      },
      error: (err) => {
        Janus.error('  -- Error attaching plugin...', err)
      },
      iceState: (state) => {
        Janus.log('ICE state (feed #' + remoteFeed.rfindex + ') changed to ' + state)
      },
      webrtcState: (on) => {
        Janus.log(
          'Janus says this WebRTC PeerConnection (feed #' +
            remoteFeed.rfindex +
            ') is ' +
            (on ? 'up' : 'down') +
            ' now'
        )
      }
    })
  }

  test() {
    console.log('remote feeds: @@@', this.feeds)
  }

  endVideoCall(): void {
    console.log('endVideoCall')
    this.localVideo.nativeElement.srcObject = null

    // this.hangup()

    // clean the Janus connection manually
    this.mystream = null
    this.localTracks = {}
    this.localVideoNum = 0
    delete this.feedStreams[this.myId]

    // close the video call window
    let stopVCCondition = {
      isVideoCall: false,
      isCallByMe: this.isCallByMe,
      isGroup: this.isGroup,
      isAdmin: this.isAdmin
    }
    // this.stopVideoCall.emit(false, this.isCallByMe, this.isGroup)
    this.stopVideoCall.emit(stopVCCondition)
  }

  stopCamera(stream): void {
    _.forEach(stream.getTracks(), (track) => {
      if (track.readyState === 'live' && track.kind === 'video') {
        track.stop()
      }
    })
  }

  stopAudio(stream): void {
    _.forEach(stream.getTracks(), (track) => {
      if (track.readyState === 'live' && track.kind === 'audio') {
        track.stop()
      }
    })
  }

  toggleAudio(): void {
    // another mic mute way in videocalltest.js
    // this.videoCallPluginHandler.send({ message: { request: "set", audio: !this.isAudioMuted }});

    this.isAudioMuted = this.videoCallPluginHandler.isAudioMuted()

    Janus.log('local audio stream is: ', this.isAudioMuted ? 'Unmuting' : 'Muting')

    if (this.isAudioMuted) {
      this.videoCallPluginHandler.unmuteAudio()
      this.videoCallPluginHandler.send({message: { request: 'configure', audio: true }})
    } else {
      this.videoCallPluginHandler.muteAudio()
      this.videoCallPluginHandler.send({message: { request: 'configure', audio: false }})
    }

    this.isAudioMuted = !this.isAudioMuted
  }

  toggleWebcam(): void {
    this.isLocalVideoMuted = this.videoCallPluginHandler.isVideoMuted()

    Janus.log('local video stream is: ', this.isLocalVideoMuted ? 'Unmuting' : 'Muting')

    if (this.isLocalVideoMuted) {
      this.videoCallPluginHandler.unmuteVideo()
      this.videoCallPluginHandler.send({message: { request: 'configure', video: true }})
    } else {
      this.videoCallPluginHandler.muteVideo()
      this.videoCallPluginHandler.send({message: { request: 'configure', video: false }})
    }

    this.isLocalVideoMuted = !this.isLocalVideoMuted
  }

  toggleSound() {
    this.isSoundMuted = !this.isSoundMuted

    // mute/unmute all audio output from other users
    _.forEach(this.feeds, (f) => {
      if (f && Boolean(f.rfindex)) {
        let audio = this.mediaEl.nativeElement.querySelector(`#remoteAudio${f.rfindex}-audio`);
        if (audio) {
          audio.muted = this.isSoundMuted
        }
      }
    })
  }

  hangup(): void {
    let hangup = { request: "hangup" };
	  this.videoCallPluginHandler.send({ message: hangup });
    this.videoCallPluginHandler.hangup()
  }

  onMouseEnter(event: any): void {
    this.isButtonGpShowing = true

    if (this.timer) {
      clearTimeout(this.timer)
    }
  }

  onMouseLeave(event: any): void {
    this.timer = setTimeout(() => { 
      this.isButtonGpShowing = false
    }, 3000)
  }
}
